import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  updateRfqMarkdown,
  UpdateRfqMarkdownPayload
} from '../api/updateRfqMarkdown';

export const useUpdateRfqMarkdown = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateRfqMarkdownPayload) => {
      return await updateRfqMarkdown(payload);
    },
    onSuccess: (_data, variables) => {
      // Invalidate the rfq query to refetch with the updated markdown
      queryClient.invalidateQueries({
        queryKey: ['rfq', variables.rfq_id.toString()]
      });
    }
  });
};
